import { DSNCDealsLarge } from 'shared-definitions/types'
import { ApiComponentDealsLarge } from 'data-source/types.wp'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { oneDealPriceMapper } from 'data-source/mappers/oneDealPriceMapper'
import { retailerButtonTitleMapper } from 'data-source/mappers/retailerButtonTitleMapper'
import { pLinkMapper, PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { optionalLinkMapper } from 'data-source/mappers/optionalLinkMapper'

export function ncDealsLarge(
  input: ApiComponentDealsLarge,
  opts: PLinkMapperOpts
): DSNCDealsLarge[] | DSNCDealsLarge {
  const image = imageMapper(input.image, opts)
  if (!image) {
    return []
  }

  return {
    abTest: 'accordion',
    resource: 'nc-deals-large',
    title: input.title,
    subtitle: input.excerpt || input.tagline,
    brand: null,
    text: input.description,
    dataAttrs: input.data_attribtues ?? {},
    pLinkRequestUpdate: null,
    pLinkEdit: optionalLinkMapper(input.edit_url),
    image,
    tags: [],
    score: null,
    buttons: input.retailers.map(item => ({
      link: {
        label: retailerButtonTitleMapper(item.name, item),
        pLink: pLinkMapper(item.url, opts),
      },
      price: oneDealPriceMapper(item),
    })),
    anchor: null,
    badges: [],
    msrp: null,
    textBadge: null,
  }
}
